/*
 * @Description: 
 * @Author: 李方强
 * @Date: 2019-12-06 09:53:45
 * @LastEditTime: 2020-03-10 15:26:13
 * @LastEditors: 李方强
 */
// state
let state = {
  types:1,  //页面条件
  orderType:{}, // 排序条件
  ruleForm:{},
  knowledgeMasterId:'',
  moreSearch:'',    //查看更多
  treeKey:[],   //树形结构
}

// getters
const getters ={
   getTypes: state => state.types,
   getOrderType:state => state.orderType,
   getRuleForm: state => state.ruleForm,
   getknowledgeMasterId: state => state.knowledgeMasterId,
   getMoreSearch: state => state.moreSearch,
   getTreeKey:state => state.treeKey,

}

//actions
const actions ={
   setTypes({commit, state},val) {
     commit('SETTYPES',val)
   },
   setOrderType({commit, state},val) {
    commit('SETORDERTYPE',val)
  },
   setRuleForm({commit, state},val) {
    commit('SETRULEFORM',val)
  },
  setknowledgeMasterId({commit, state},val) {
    commit('SETKNOWLEDGEMASTERID',val)
  },
  setmoreSearch({commit,state},val) {
    commit('SETMORESEARCH',val)
  },
  setTreeKey({commit,state},val) {
    commit('SETTREEKEY',val)
  }
}

const mutations ={
  SETTYPES(state, val) {
    //通知SETTYPES
    state.types = val
  },
  SETORDERTYPE(state, val) {
    //通知SETTYPES
    state.orderType = val
  },
  SETRULEFORM(state, val) {
    //通知SETRULEFORM
    console.log(val)
    state.ruleForm = val
  },
  SETKNOWLEDGEMASTERID(state, val) {
    //通知SETKNOWLEDGEMASTERID
    state.knowledgeMasterId = val
  },
  SETMORESEARCH(state,val) {
    state.moreSearch = val
  },
  SETTREEKEY(state,val) {
    state.treeKey = val
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}